import { type SpinnerProps } from "./types";
import { useTheme } from "@repo/tokens";
import { resolveThemeToken } from "../../utils/theme";

export const Spinner = ({
  size = "md",
  color = "action.primary.default",
  label = "Loading...",
  testID,
  id,
}: SpinnerProps) => {
  const { theme } = useTheme();

  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48,
    "2xl": 96,
  };

  const pxSize = sizeMap[size];
  const resolvedColor = resolveThemeToken(theme, color);

  // Using simple SVG with animateTransform
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      id={id}
      data-testid={testID}
      style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
    >
      <svg
        width={pxSize}
        height={pxSize}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        style={{ color: resolvedColor }}
      >
        <g>
          <circle
            cx="12"
            cy="12"
            r="9.5"
            fill="none"
            strokeWidth="3"
            strokeOpacity="0.2"
            stroke="currentColor"
          />
          <path
            d="M12 2.5C6.75 2.5 2.5 6.75 2.5 12"
            stroke="currentColor"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 12 12"
              to="360 12 12"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </svg>
      <span
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0,0,0,0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        {label}
      </span>
    </div>
  );
};
